import { createRouter, createWebHistory } from "vue-router";
import RootView from "../views/RootView.vue";
import LoginView from "../views/LoginView.vue";
import HomeView from "../views/HomeView.vue";
import SettingsView from "../views/settings/SettingsView.vue";
import InitView from "../views/InitView.vue";
import ChangePasswordView from "../views/ChangePasswordView.vue";

const routes = [
  {
    path: "/",
    name: "root",
    component: RootView,
    meta: {
      title: "Root",
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      title: "Log in",
    },
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    meta: {
      title: "Home",
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsView,
    meta: {
      title: "Settings",
    },
  },
  {
    path: "/init-modul",
    name: "init-modul",
    component: InitView,
    meta: {
      title: "Init Modul",
    },
  },
  {
    path: "/change-password",
    name: "change-password",
    component: ChangePasswordView,
    meta: {
      title: "Password change",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to /* from */) => {
  document.title =
    to.meta && to.meta.title ? `${to.meta.title} - Modul` : "Modul";
});

export default router;
